// extracted by mini-css-extract-plugin
export var discard = "_2c-4";
export var muiTooltipTooltip = "_2c-6";
export var notificationBar = "_2c-3";
export var notificationContainer = "_2c-2";
export var saveButtonHoverSlotWrapper = "_2c-5";
export var show = "_2c-1";
export var spacer = "_2c-0";